import React, { useState } from "react";
import ASSET_PATHS from "../../../assets/config/assetPaths";
import { useSwipeable } from "react-swipeable";
import { useNavigate } from "react-router-dom";
import { WorkOrder } from "../../../redux/slices/workOrderSlice";
import { WorkOrderStatus } from "../../../types/workOrder";

interface AssetCardProps {
    asset: any;
    workOrder_ID: number;
    workOrder: WorkOrder;
    onOpenSkipModal: (asset: any) => void;
    onOpenUnSkipModal: (asset: any) => void;
}


const AssetCard: React.FC<AssetCardProps> = ({
    asset,
    workOrder_ID,
    workOrder,
    onOpenSkipModal,
    onOpenUnSkipModal,
}) => {
    const navigate = useNavigate();
    const [showIcon, setShowIcon] = useState(false);

    const handlers =
        workOrder?.workOrderStatus !== WorkOrderStatus.Completed
            ? useSwipeable({
                onSwipedLeft: () => setShowIcon(true),
                onSwipedRight: () => setShowIcon(false),
                preventScrollOnSwipe: true,
                trackMouse: true,
            })
            : {};

    const handleSkipUnSkipClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        if (asset.status_ID == 4) {
            onOpenUnSkipModal(asset);
        } else {
            onOpenSkipModal(asset);
        }
        setShowIcon(false);
    };

    const handleCardClick = () => {
        if (asset.status_ID !== 4)
            navigate(`/order/${workOrder_ID}/inspection/${asset?.item_ID}`);
    };

    return (
        <div className="relative rounded-xl shadow-md flex justify-between cursor-pointer transition-all duration-300">
            <div className="bg-primary bg-opacity-80 rounded-xl w-full">
                <div
                    {...handlers}
                    className={`relative p-3 shadow-card-shadow w-full ${!showIcon && "rounded-xl"
                        } border-gray-100 border bg-white flex justify-between h-full cursor-pointer transition-all duration-300 ${showIcon ? "translate-x-[-80px]" : "translate-x-0"
                        }`}
                    onClick={handleCardClick}
                >
                    {showIcon && (
                        <div className="bg-red absolute right-[-50px] top-1/2 transform -translate-y-1/2 flex items-center">
                            <img
                                onClick={handleSkipUnSkipClick}
                                src={
                                    asset.status_ID == 4
                                        ? ASSET_PATHS.unskipWhite
                                        : ASSET_PATHS.blockIcon
                                }
                                alt="Delete Icon"
                                className="h-8 w-8"
                            />
                        </div>
                    )}

                    <div className="bg-white flex flex-col space-y-2 max-w-[60%]">
                        <p className="font-medium text-sm">{asset?.description}</p>
                        <p className="text-xs">
                            ITEM ID:{" "}
                            {asset?.item_ID.toString().length === 13
                                ? "Pending"
                                : asset?.item_ID}
                        </p>
                        <p className="text-xs">STOCK #: {asset?.stockNumber || "-"}</p>
                        <p className="text-xs">SN/VIN: {asset?.vin}</p>
                    </div>

                    <div className="p-4">
                        <div className="flex flex-col items-end gap-2 absolute top-3 right-3 ">
                            <div className="bg-orange-500 px-3 pt-[0.4px] rounded-full text-[11px] font-medium text-white flex items-center justify-center gap-1">
                                {`Modules ${asset?.totalVerifiedModules}/${asset?.modules?.length}`}
                            </div>
                        </div>

                        <div className="flex flex-col items-end justify-between absolute bottom-3 right-3">
                            {asset?.isUploading ? (
                                <div className="mt-auto flex text-primary text-xs items-center font-semibold gap-1">
                                    <img src={ASSET_PATHS.cloudUpload} alt="Upload" /> Uploading
                                </div>
                            ) : asset?.isRetrying ? (
                                <div className="mt-auto flex-col items-center gap-1">
                                    <span className="text-[0.5rem]">Currently Offline</span>
                                    <div className="mt-auto flex text-red-400 text-xs items-center justify-end font-semibold gap-1">
                                        <img src={ASSET_PATHS.refresh} alt="Retry" /> Retry
                                    </div>
                                </div>
                            ) : asset.status_ID == 4 ? (
                                <div className="mt-auto flex-col items-center gap-1">
                                    <div className="mt-auto flex-col items-center gap-1">
                                        <div className="mt-auto flex text-primary text-xs items-center justify-end font-semibold gap-1">
                                            Skipped
                                        </div>
                                    </div>
                                </div>
                            ) : asset?.totalVerifiedModules === asset?.modules?.length ? (
                                <div className="mt-auto flex-col items-center gap-1">
                                    <div className="mt-auto flex text-green-500 text-xs items-center justify-end font-semibold gap-1">
                                        <img src={ASSET_PATHS.checkCircle} alt="done" /> Done
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssetCard;
